import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import {
  BankingEntitiesTransactionTypeEnum,
  TransactionDetailFragment,
} from 'generated/resources/graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import AmountWithCurrency from 'modules/expenses/lib/transactions/AmountWithCurrency'

const TransactionType = ({ type }: { type: BankingEntitiesTransactionTypeEnum }) => {
  const htmlBox = (text: string) => (
    <Tag type="malibu" inline>
      {text}
    </Tag>
  )

  switch (type) {
    case 'topup':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.topup'))
    case 'payroll':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.payroll'))
    case 'card_payment':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.card_payment'))
    case 'card_refund':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.card_refund'))
    case 'dispute':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.dispute'))
    case 'fees':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.fees'))
    case 'payment':
      return htmlBox(i18n.t('expenses_v2.transactions.list.types.refund'))
    case 'outgoing_transfer':
      return htmlBox(i18n.t('banking.accounts.transaction_type.outgoing_transfer'))
    case 'incoming_transfer':
      return htmlBox(i18n.t('banking.accounts.transaction_type.incoming_transfer'))
    case 'outgoing':
      return htmlBox(i18n.t('banking.accounts.transaction_type.outgoing'))
    case 'incoming':
      return htmlBox(i18n.t('banking.accounts.transaction_type.incoming'))
    case 'unknown':
    default:
      return htmlBox('')
  }
}

export const DefaultDetails = ({
  amountCents,
  balanceAfterCents,
  currency,
  bookingDate,
  type,
}: TransactionDetailFragment) => {
  return (
    <>
      <Box width="full" justifyContent="flexStart" alignItems="flexStart" gap="s16">
        <Text.Header2 color="grey1000">
          {i18n.t('expenses_v2.transactions.detail.sections.transaction_details')}
        </Text.Header2>
        <Box width="full" flexDirection="row" justifyContent="flexStart" alignItems="flexStart">
          <Box width="full" textAlign="left" gap="s8">
            <Text weight="medium" size="300" color="grey1000">
              {i18n.t('expenses_v2.transactions.detail.fields.type')}
            </Text>
            <Box height="s24">
              <TransactionType type={type} />
            </Box>
          </Box>
          <Box width="full" textAlign="left" gap="s8">
            <Text weight="medium" size="300" color="grey1000">
              {i18n.t('expenses_v2.transactions.detail.fields.transaction_date')}
            </Text>
            <Text weight="normal" size="300" color="grey800">
              {dateBackendDateTimeToUI(bookingDate)}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box width="full" flexDirection="row" justifyContent="flexStart" alignItems="flexStart">
        <Box width="full" textAlign="left" gap="s8">
          <Text weight="medium" size="300" color="grey1000">
            {i18n.t('banking.attributes.amount')}
          </Text>
          <Text weight="normal" size="300" color="grey800">
            <AmountWithCurrency amount={amountCents} currency={currency} />
          </Text>
        </Box>
        {balanceAfterCents && (
          <Box width="full" textAlign="left" gap="s8">
            <Text weight="medium" size="300" color="grey1000">
              {i18n.t('banking.attributes.balance')}
            </Text>
            <Text weight="normal" size="300" color="grey800">
              <AmountWithCurrency amount={balanceAfterCents} currency={currency} />
            </Text>
          </Box>
        )}
      </Box>
    </>
  )
}
